import { render } from "./StartQuestionView.vue?vue&type=template&id=70c3e530"
import script from "./StartQuestionView.vue?vue&type=script&lang=js"
export * from "./StartQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__